import {
  ICreateLegalEntityParams,
  ILegalEntity,
  IWaiveLegalEntityDocumentParams,
} from '@common/interfaces/legalEntity'
import { IApi } from '../../api'
import { createAction } from '../types'

export const prefix = 'legalEntities'

export const LIST_REQUEST = `${prefix}/LIST_REQUEST`
export const LIST_SUCCESS = `${prefix}/LIST_SUCCESS`
export const LIST_FAILURE = `${prefix}/LIST_FAILURE`

export const listLegalEntities = createAction((clientId: string) => ({
  type: [LIST_REQUEST, LIST_SUCCESS, LIST_FAILURE],
  promise: (api: IApi) => api.legalEntities.list(clientId),
}))

export const CREATE_REQUEST = `${prefix}/CREATE_REQUEST`
export const CREATE_SUCCESS = `${prefix}/CREATE_SUCCESS`
export const CREATE_FAILURE = `${prefix}/CREATE_FAILURE`

export const createLegalEntity = createAction((data: ICreateLegalEntityParams) => ({
  type: [CREATE_REQUEST, CREATE_SUCCESS, CREATE_FAILURE],
  promise: (api: IApi) => api.legalEntities.create(data),
}))

export const UPDATE_REQUEST = `${prefix}/UPDATE_REQUEST`
export const UPDATE_SUCCESS = `${prefix}/UPDATE_SUCCESS`
export const UPDATE_FAILURE = `${prefix}/UPDATE_FAILURE`

export const updateLegalEntity = createAction(
  (id: string, data: Partial<Pick<ILegalEntity, 'entityName' | 'incState' | 'hqState'>>) => ({
    type: [UPDATE_REQUEST, UPDATE_SUCCESS, UPDATE_FAILURE],
    promise: (api: IApi) => api.legalEntities.update(id, data),
  }),
)

export const DELETE_REQUEST = `${prefix}/DELETE_REQUEST`
export const DELETE_SUCCESS = `${prefix}/DELETE_SUCCESS`
export const DELETE_FAILURE = `${prefix}/DELETE_FAILURE`

export const deleteLegalEntity = createAction((id: string) => ({
  type: [DELETE_REQUEST, DELETE_SUCCESS, DELETE_FAILURE],
  promise: (api: IApi) => api.legalEntities.delete(id),
}))

export const WAIVE_REQUEST = `${prefix}/WAIVE_REQUEST`
export const WAIVE_SUCCESS = `${prefix}/WAIVE_SUCCESS`
export const WAIVE_FAILURE = `${prefix}/WAIVE_FAILURE`

export const waiveLegalEntity = createAction(
  (id: string, data: { waived: boolean; waivedNote?: string }) => ({
    type: [WAIVE_REQUEST, WAIVE_SUCCESS, WAIVE_FAILURE],
    promise: (api: IApi) => api.legalEntities.waive(id, data),
  }),
)

export const WAIVE_DOCUMENT_REQUEST = `${prefix}/WAIVE_DOCUMENT_REQUEST`
export const WAIVE_DOCUMENT_SUCCESS = `${prefix}/WAIVE_DOCUMENT_SUCCESS`
export const WAIVE_DOCUMENT_FAILURE = `${prefix}/WAIVE_DOCUMENT_FAILURE`

export const waiveLegalEntityDocument = createAction(
  (id: string, data: IWaiveLegalEntityDocumentParams) => ({
    type: [WAIVE_DOCUMENT_REQUEST, WAIVE_DOCUMENT_SUCCESS, WAIVE_DOCUMENT_FAILURE],
    promise: (api: IApi) => api.legalEntities.waiveDocument(id, data),
  }),
)

export const UNWAIVE_DOCUMENT_REQUEST = `${prefix}/UNWAIVE_DOCUMENT_REQUEST`
export const UNWAIVE_DOCUMENT_SUCCESS = `${prefix}/UNWAIVE_DOCUMENT_SUCCESS`
export const UNWAIVE_DOCUMENT_FAILURE = `${prefix}/UNWAIVE_DOCUMENT_FAILURE`

export const unwaiveLegalEntityDocument = createAction((id: string, waiverId: string) => ({
  type: [UNWAIVE_DOCUMENT_REQUEST, UNWAIVE_DOCUMENT_SUCCESS, UNWAIVE_DOCUMENT_FAILURE],
  promise: (api: IApi) => api.legalEntities.unwaiveDocument(id, waiverId),
}))
